export default "__VITE_ASSET__CV0ku4z$__"